import $ from "jquery"
import { _throttle } from "../utils"
export default {
  data() {
    return {
      moveStartX: undefined,
      moveStartY: undefined,
      moveX: undefined,
      moveY: undefined,
      isNewPageMove: false,
      touchMoveEndAnimate: false,
      autoPlayAnimate: false,
      // showStageIndex: 0,
      oldStageIndex: 1,
      animateTimer: null,
      animateOrder: undefined, //翻页的方向： 上一页 下一页
      noTouchEndAnimate: true
    }
  },
  computed: {
    showStageIndex: {
      get() {
        return this.dataSource.children.findIndex(it => it.isActive)
      },
      set(val) {
        this.changeActiveStage(this.dataSource.children[val].container_id)
      }
    },
    animateType() {
      let container = this.dataSource.children[this.showStageIndex]
      if (container.options.containerAnimateSet) {
        return container.options.containerAnimateSet.animateType
      }
    },
    animateDirection() {
      let container = this.dataSource.children[this.showStageIndex]
      if (container.options.containerAnimateSet) {
        return container.options.containerAnimateSet.direction
      }
    }
  },
  watch: {
    moveX(newVal) {
      if (this.animateDirection === "upDown") {
        return
      }
      // 上一页
      if (newVal > 0 && this.showStageIndex > -1) {
        this.prevAnimateSet()
      }
      // 下一页
      if (newVal < 0 && this.showStageIndex < this.dataSource.children.length) {
        this.nextAnimateSet()
      }
    },
    moveY(newVal) {
      if (this.animateDirection === "leftRight") {
        return
      }
      // 上一页
      if (newVal > 0 && this.showStageIndex > -1) {
        this.prevAnimateSet()
      }
      // 下一页
      if (newVal < 0 && this.showStageIndex < this.dataSource.children.length) {
        this.nextAnimateSet()
      }
    },
    showStageIndex(newVal, oldVal) {
      this.oldStageIndex = oldVal
      this.executionAnimate()
      // 执行动画
      if (this.isEditMode) {
        return
      }
      this.$nextTick(() => {
        if (this.autoPlayAnimate) {
          setTimeout(() => {
            $($(".myContainer")[this.showStageIndex]).addClass("cx-animate")
            $($(".myContainer")[this.oldStageIndex]).addClass("cx-animate")
          }, 10)
        } else {
          $($(".myContainer")[this.oldStageIndex]).addClass("animate-current")
          $($(".myContainer")[newVal]).removeClass("animate-current").addClass("animate-active")
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pageUpMouseEvent()
      this.executionAnimate()
    })
  },
  methods: {
    executionAnimate() {
      if (!this.isPhoneFullScreen) {
        return
      }
      if (this.dataSource.children[this.showStageIndex]) {
        this.dataSource.children[this.showStageIndex].children.forEach(childItem => {
          let ids = {
            container_id: this.dataSource.children[this.showStageIndex].container_id,
            rect_id: childItem.rect_id,
            uid: null,
            elementInLayoutId: null
          }
          // this.$changeOptionsEV("animate__animated", "executionAnimateClass", true, "animateSets", ids)
        })
      }
      if (this.oldStageIndex !== this.showStageIndex && this.dataSource.children[this.oldStageIndex]) {
        this.dataSource.children[this.oldStageIndex].children.forEach(childItem => {
          let ids = {
            container_id: this.dataSource.children[this.oldStageIndex].container_id,
            rect_id: childItem.rect_id,
            uid: null,
            elementInLayoutId: null
          }
          // this.$changeOptionsEV("", "executionAnimateClass", true, "animateSets", ids)
        })
      }
    },
    changeEditMode() {
      this.isEditMode = !this.isEditMode
      // 预览模式
      if (!this.isEditMode) {
        $($(".myContainer")[this.showStageIndex]).addClass("animate-current")
        this.changeActiveStage(this.dataSource.children[0].container_id)
      } else {
        $(".myContainer.animate-current").removeClass("animate-current")
        $(".myContainer.animate-active").removeClass("animate-active")
        this.changeActiveStage(this.dataSource.children[this.showStageIndex].container_id)
      }
    },
    // 播放页面动画
    playAnimate() {
      this.showStageIndex =
        this.animateOrder === "pause"
          ? this.showStageIndex + 1
          : this.showStageIndex === 0
          ? this.showStageIndex + 1
          : 0
      this.$nextTick(() => {
        this.autoPlayAnimate = true
        this.animateOrder = "play"
        this.animateEvent()
      })
    },
    animateEvent() {
      let time = this.containerAnimateTime[this.showStageIndex]
      $($(".myContainer")[this.showStageIndex])
        .off("webkitTransitionEnd")
        .on("webkitTransitionEnd", () => {
          if (this.animateOrder === "play" && this.showStageIndex === this.dataSource.children.length - 1) {
            this.animateOrder = undefined
          }
          this.autoPlayAnimate = false
          $($(".myContainer")[this.showStageIndex]).off("webkitTransitionEnd")
        })
      switch (this.animateOrder) {
        case "prev":
          break
        case "next":
          break
        case "pause":
          break
        case "play":
          this.animateTimer = setTimeout(() => {
            if (this.showStageIndex < this.dataSource.children.length - 1) {
              this.autoPlayAnimate = true
              this.showStageIndex = this.showStageIndex + 1
              if (this.showStageIndex < this.dataSource.children.length) {
                this.animateEvent()
              }
            }
          }, time * 1000)
          break
        default:
      }
    },
    // 暂停动画
    stopAnimate() {
      this.animateOrder = "pause"
    },

    // 上一页 带动画
    prevStage() {
      if (this.showStageIndex > 0) {
        this.animateOrder = "prev"
        this.autoPlayAnimate = true
        this.showStageIndex = this.showStageIndex - 1
        // this.prevAnimate()
        this.animateEvent()
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "info",
          message: "当前已经是第一页了"
        })
      }
    },
    //下一页 带动画
    nextStage() {
      if (this.showStageIndex < this.dataSource.children.length - 1) {
        this.animateOrder = "next"
        this.autoPlayAnimate = true
        this.showStageIndex = this.showStageIndex + 1
        this.animateEvent()
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "info",
          message: "当前已经是最后一页了"
        })
      }
    },
    // 判断touch 结束后是否执行动画
    judgeTouchEndAnimate() {
      // if (this.animateDirection === "leftRight" && this.moveX === 0) {
      //   return true
      // }
      // if (this.animateDirection === "upDown" && this.moveY === 0) {
      //   return true
      // }
      return this.noTouchEndAnimate
    },
    // touch 结束之后的动画
    touchEndAnimate() {
      if (this.judgeTouchEndAnimate()) {
        return
      }
      this.touchMoveEndAnimate = true
      this.autoPlayAnimate = true
      switch (this.animateType) {
        case "regular":
          setTimeout(() => {
            if (this.touchMoveEndAnimate) {
              $(".myContainer.animate-active").css("transform", "")
            }
            $($(".myContainer")[this.showStageIndex]).addClass("cx-animate")
          }, 10)
          break
        case "inertia":
          setTimeout(() => {
            if (this.touchMoveEndAnimate) {
              $($(".myContainer")[this.showStageIndex]).css("transform", "translate(0,0)")
              $($(".myContainer")[this.oldStageIndex]).css("transform", "scale(0)")
            }
            $($(".myContainer")[this.showStageIndex]).addClass("cx-animate")
            $($(".myContainer")[this.oldStageIndex]).addClass("cx-animate")
          }, 100)
          break
        default:
      }
      $($(".myContainer")[this.showStageIndex])
        .off("webkitTransitionEnd")
        .on("webkitTransitionEnd", () => {
          if (this.showStageIndex === this.dataSource.children.length - 1) {
            this.animateOrder = undefined
          }
          this.autoPlayAnimate = false
          this.touchMoveEndAnimate = false
          $($(".myContainer")[this.showStageIndex]).css("transform", "")
          $($(".myContainer")[this.oldStageIndex]).css("transform", "")
          $($(".myContainer")[this.showStageIndex]).removeClass("cx-animate")
          $($(".myContainer")[this.showStageIndex]).off("webkitTransitionEnd")
        })
    },
    prevAnimateSet() {
      if (this.isNewPageMove && this.showStageIndex === 0) {
        this.noTouchEndAnimate = true
        return
      }
      this.noTouchEndAnimate = false
      if (this.isNewPageMove) {
        this.showStageIndex = this.showStageIndex - 1
      }
      this.isNewPageMove = false
      switch (this.animateType) {
        case "regular":
          if (this.animateDirection === "leftRight") {
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateX(calc(-100% + ${Math.abs(this.moveX)}px)`
            })
          }
          if (this.animateDirection === "upDown") {
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateY(calc(-100% + ${Math.abs(this.moveY)}px)`
            })
          }
          break
        case "inertia":
          let pageScale = 1
          if (this.animateDirection === "leftRight") {
            pageScale = 1 - Math.abs(this.moveX) / $(".myContainer").width()
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateX(calc(-100% + ${Math.abs(this.moveX)}px)`
            })
          }
          if (this.animateDirection === "upDown") {
            pageScale = 1 - Math.abs(this.moveY) / $(".myContainer").height()
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateY(calc(-100% + ${Math.abs(this.moveY)}px)`
            })
          }
          $($(".myContainer")[this.oldStageIndex]).css({
            transform: `scale(${pageScale})`
          })
          break
        default:
      }
    },
    nextAnimateSet() {
      if (this.isNewPageMove && this.showStageIndex === this.dataSource.children.length - 1) {
        this.noTouchEndAnimate = true
        return
      }
      this.noTouchEndAnimate = false
      if (this.isNewPageMove) {
        // this.oldStageIndex = this.showStageIndex
        this.showStageIndex = this.showStageIndex + 1
        // this.showStageIndex > this.dataSource.children.length - 2
        //   ? this.dataSource.children.length - 1
        //   : this.showStageIndex + 1
      }
      this.isNewPageMove = false
      // this.$nextTick(() => {
      switch (this.animateType) {
        case "regular":
          if (this.animateDirection === "leftRight") {
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateX(calc(100% - ${Math.abs(this.moveX)}px)`
            })
          }
          if (this.animateDirection === "upDown") {
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateY(calc(100% - ${Math.abs(this.moveY)}px)`
            })
          }
          break
        case "inertia":
          let pageScale = 1
          if (this.animateDirection === "leftRight") {
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateX(calc(100% - ${Math.abs(this.moveX)}px)`
            })
            pageScale = 1 - Math.abs(this.moveX) / $(".myContainer").width()
          }
          if (this.animateDirection === "upDown") {
            $($(".myContainer")[this.showStageIndex]).css({
              transform: `translateY(calc(100% - ${Math.abs(this.moveY)}px)`
            })
            pageScale = 1 - Math.abs(this.moveY) / $(".myContainer").height()
          }
          $($(".myContainer")[this.oldStageIndex]).css({
            transform: `scale(${pageScale})`
          })
          break
        default:
      }
      // })
    },
    pageUpMouseEvent() {
      let _this = this
      $(".edit_bg").on("mousedown touchstart", ".myContainer", function (e) {
        // 不支持自动播放的时候 用户自行操作
        if (_this.autoPlayAnimate || _this.isEditMode) {
          return
        }
        _this.isNewPageMove = true
        _this.moveStartX = e.clientX
        _this.moveStartY = e.clientY
      })
      $(".edit_bg").on("mousemove touchmove", ".myContainer", function (e) {
        _throttle(e => {
          if (_this.autoPlayAnimate || _this.isEditMode || !_this.moveStartX) {
            return
          }
          // 解决安卓机在顶部的时候 不触发touchstart  moveStartX 为undefined的情况
          _this.moveStartX = typeof _this.moveStartX === "undefined" ? e.clientX : _this.moveStartX
          _this.moveStartY = typeof _this.moveStartY === "undefined" ? e.clientY : _this.moveStartY
          _this.moveX = e.clientX - _this.moveStartX
          _this.moveY = e.clientY - _this.moveStartY
        }, 50)(e)
      })
      $(".edit_bg").on("mouseup touchend", ".myContainer", function (e) {
        // 不支持自动播放的时候 用户自行操作
        if (_this.autoPlayAnimate || _this.isEditMode) {
          return
        }
        if (
          (_this.animateDirection === "leftRight" && !_this.moveX) ||
          (_this.animateDirection === "upDown" && !_this.moveY)
        ) {
          return
        }
        _this.moveX = 0
        _this.moveY = 0
        _this.moveStartX = undefined
        _this.moveStartY = undefined
        _this.isNewPageMove = false
        _this.touchEndAnimate()
      })
    }
  }
}
